module.exports = __webpack_public_path__ + "app/principal/group/principal-group-detail-7iPxQ2hK.html";